<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 14:20:23
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-23 18:25:38
-->
<template>
	<span class="flex-row flex-align-center">
		<el-button @click="click">
			<i class="el-icon-loading" v-if="isLoading"></i>
			{{ curStatusText }}
		</el-button>
		<template>
			<p v-if="isLoading" class="yx-color-text-regular fz-14 ml-10">
				商品数据同步进度：
				<span class="yx-color-primary">{{ ratio }}%</span>
			</p>
			<p v-else-if="isError" class="yx-color-warning fz-14 ml-10">
				<el-tooltip :content="errMsg" placement="bottom">
					<span>
						<i class="el-icon-warning"></i>
						同步失败
					</span>
				</el-tooltip>
			</p>
			<p v-else class="yx-color-text-regular fz-14 ml-10">最近同步时间：{{ syncTime }}</p>
		</template>
		<async-dialog ref="asyncDialog" :platformId="platformId" :sourceData="sourceData" @back="openSyncGoods"></async-dialog>
		<auth-alert-dialog ref="authAlertDialog"></auth-alert-dialog>
		<tips ref="tips"></tips>
		<choose-async-task-dialog ref="chooseAsyncTaskDialog" @startAsyncTask="startAsyncTask" @seeTaskList="showAsyncDialog"></choose-async-task-dialog>
	</span>
</template>
<script>
import AsyncDialog from '../asyncDialog.vue';
import authMixin from '@/modules/auth/mixin';
import AuthAlertDialog from '@/modules/auth/alert';
import ChooseAsyncTaskDialog from './chooseAsyncTaskDialog.vue';
import LoopManger from '@/utils/loop';
import { pullSyncStatus, taskProgressInfo } from '@/api/shopManage';
// 异步状态
const ASYNC_DEFAULT_STATUS = 0; //待执行
const ASYNC_PENDING_STATUS = 10; //执行中
const ASYNC_RETRY_STATUS = 20; //重试
const ASYNC_CANCEL_STATUS = 30; //用户取消
const ASYNC_SUCCESS_STATUS = 40; //全部成功
const ASYNC_PARTSUCCESS_STATUS = 41; //部分成功
const ASYNC_FAIL_STATUS = 42; //失败
const statusConf = {
	[ASYNC_DEFAULT_STATUS]: '同步商品',
	[ASYNC_PENDING_STATUS]: '同步中',
	[ASYNC_FAIL_STATUS]: '同步商品',
	[ASYNC_PARTSUCCESS_STATUS]: '同步商品',
	[ASYNC_SUCCESS_STATUS]: '同步商品',
};
export default {
	name: 'GoodsAsyncButton',
	mixins: [authMixin],
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
		needAuth: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		platformId: {
			handler(to) {
				this.reset();
				this.getCurrentTask();
			},
			immediate: true,
		},
	},
	data() {
		return {
			status: '0', // 按钮当前状态
			taskId: '', // 当前任务ID
			ratio: 0, // 进度条比例
			errMsg: '', // 错误提示信息
			syncTime: '-', // 最近同步时间
			loading: false, // 同步商品按钮loading状态
			loop: null, // 定时器对象
			sourceData: {
				status: 10,
				taskProgress: 0,
			},
			failTimes: 0, // 轮询失败次数
			institution_id: '',
		};
	},
	computed: {
		isLoading() {
			return this.status === ASYNC_PENDING_STATUS;
		},
		isError() {
			return this.status === ASYNC_FAIL_STATUS || this.status === ASYNC_PARTSUCCESS_STATUS;
		},
		isSuccess() {
			return this.status === ASYNC_SUCCESS_STATUS;
		},
		curStatusText() {
			return statusConf[this.status] || '同步商品';
		},
	},
	methods: {
		async getCurrentTask() {
			return new Promise(async (rs, rj) => {
				try {
					const temPF = {
						[dataMap.PLATFORM_DY.value]: '12',
						[dataMap.PLATFORM_SP.value]: '31',
					};
					const data = await pullSyncStatus({
						tripartiteType: temPF[this.platformId],
						platformId: this.platformId,
						type: '2', //1-返回最近成功的任务 2-返回最近发起的任务
					});
					if (data.taskId) {
						this.status = data.status;
						this.errMsg = data.errorMsg;
						this.taskId = data.taskId;
						this.syncTime = data.latelySuccessTime;
						this.sourceData = data;
						if (this.status === ASYNC_PENDING_STATUS) {
							this.pollGetTaskInfo();
						}
					}
					return rs();
				} catch (error) {
					this.$message.error(error.mesage);
					return rj(error);
				}
			});
		},
		async click() {
			try {
				// 如果需要进行授权检测
				if (this.needAuth) {
					await this.checkAuth(this.platformId);
				}
			} catch (error) {
				return;
			}
			this.$refs.chooseAsyncTaskDialog.show(this.platformId);
		},
		openSyncGoods() {
			this.$refs.chooseAsyncTaskDialog.show(this.platformId);
		},
		// 单个任务进度查找
		getTaskInfo() {
			return new Promise(async (rs, rj) => {
				try {
					const { code, data, message } = await taskProgressInfo({
						taskIdList: [this.taskId],
						requireParam: true,
					});
					if (code === 0) {
						let obj = data[0];
						this.status = obj.status;
						this.ratio = obj.taskProgress;
						if (this.status !== ASYNC_PENDING_STATUS) {
							this.getCurrentTask();
						} else {
							this.sourceData = obj;
						}

						return rs(obj);
					}
					return rj({ code, message });
				} catch (error) {
					return rj(error);
				}
			});
		},
		async pollGetTaskInfo() {
			return new Promise(async rs => {
				if (this.loop) {
					this.loop.start();
				} else {
					this.loop = new LoopManger(this.pollCallBack);
				}
				this.failTimes = 0;
				return rs();
			});
		},
		showAsyncDialog() {
			this.$refs.asyncDialog.show();
		},
		async pollCallBack() {
			return new Promise(async rs => {
				try {
					await this.getTaskInfo();
					rs();
					// 成功就把失败次数清零
					this.failTimes = 0;
					// 结果不是在执行中就停止轮询
					if (!this.isLoading) this.clearLoop();
					// clearInterval(this.timer);
					// 结果成功弹出成功message
					if (this.isError) this.$message.error('同步失败：' + this.errMsg);
					if (this.isSuccess) this.$message.success('商品同步成功'), this.$emit('refresh');
				} catch (error) {
					// 接口获取失败一次就把失败次数+1
					this.failTimes += 1;
					if (this.failTimes >= 3) {
						this.$message.error('接口失败次数过多，请稍后重试');
						// 还原
						this.reset();
					}
				}
			});
		},
		async startAsyncTask(val) {
			this.taskId = val;
			// 开启任务成功之后进行任务信息轮询
			await this.pollGetTaskInfo();
			// 展示进度弹窗
			this.showAsyncDialog();
		},
		// 把状态置为默认状态，最近同步时间置为‘-’，关闭同步进度弹窗，清除定时器
		reset() {
			this.status = ASYNC_DEFAULT_STATUS;
			this.syncTime = '-';
			this.$refs.asyncDialog?.hide();
			this.clearLoop();
			this.failTimes = 0;
		},
		clearLoop() {
			this.loop?.stop();
			this.loop = null;
		},
	},
	beforeDestroy() {
		this.clearLoop();
	},
	components: {
		AsyncDialog,
		Tips: () => import('@/modules/auth/tips.vue'),
		AuthAlertDialog,
		ChooseAsyncTaskDialog,
	},
};
</script>
